module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Ga-Hb-Ia.922493c1.png";